export enum AppRoutesEnum {
    BASE = '',

    DASHBOARD = '/checkmate/listing',
    CKM_LISTING = '/checkmate/listing',
    CKM_DETAILS = '/checkmate/details',
    CKM_SETUP = '/checkmate/setup',
}
